<template>
    <productVariationComp />
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const productVariationComp = defineAsyncComponent(() => import('@/components/managementPages/productVariationPage/productVariationComp.vue'))
</script>